// extracted by mini-css-extract-plugin
export default {"container":"product-banner_container__DnDRr","image_container":"product-banner_image_container__GeOPf","fields_container":"product-banner_fields_container__yady9"};